module.exports = __webpack_public_path__ + "static/media/Iamob.5d66bc8d.jpeg";